<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">

                <!-- Empty State -->
                <div class="text-center py-5" *ngIf="mainResponse.length == 0">
                    <div class="ultimate-3d-card p-5 mx-auto" style="max-width: 400px;">
                        <i class="fa-solid fa-video" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                        <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Album Data Found</h3>
                    </div>
                </div>

                <ng-container *ngIf="mainResponse.length != 0">

                    <!-- Breadcrumbs -->
                    <div class="mb-5 text-center" *ngIf="folders.length">
                        <div class="ultimate-3d-card d-inline-flex px-4 py-2 mx-auto" style="border-radius: 30px;">
                            <div class="d-flex flex-wrap align-items-center" style="font-weight: 600; font-size: 14px;">
                                <a style="cursor: pointer; color: #0d8b54; text-decoration: none; transition: color 0.3s ease;"
                                    class="hover-success" [routerLink]="['/video-gallery']">Home</a>
                                <div class="mx-3" style="color: #94a3b8;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                                <ng-container *ngFor="let path of folders; let last = last; trackBy: trackByFn2">
                                    <ng-container *ngIf="!last">
                                        <a style="cursor: pointer; color: #0d8b54; text-decoration: none; transition: color 0.3s ease;"
                                            class="hover-success" (click)="Goto(path.id)">{{ path.name }}</a>
                                        <div class="mx-3" style="color: #94a3b8;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="last">
                                        <div style="color: #0f4c3a; font-weight: 700;">
                                            {{ path.name }}
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- Folders Section -->
                    <div class="mb-5" *ngIf="album.length != 0">
                        <div class="text-center mb-4">
                            <h2 class="ultimate-3d-title" style="font-size: 32px;">Folders</h2>
                            <div class="premium-header-divider mx-auto mt-2" style="width: 50px;"></div>
                        </div>
                        <div class="row g-4 justify-content-center">
                            <ng-container *ngFor="let album of album">
                                <div class="col-lg-4 col-md-6">
                                    <a [routerLink]="['/videoFolder', album.Id]" class="text-decoration-none">
                                        <div class="ultimate-3d-card gallery-3d-card h-100 d-flex flex-column">
                                            <div class="gallery-image-wrapper youtube-wrapper d-flex align-items-center justify-content-center"
                                                style="background: rgba(13, 139, 84, 0.1);">
                                                <img [src]="'/assets/img/youtube.png'" class="img-fluid"
                                                    style="width: 80px; height: 80px; object-fit: contain;"
                                                    alt="Video Album" (load)="onImageLoad()" />
                                            </div>
                                            <div
                                                class="gallery-content p-4 text-center flex-grow-1 d-flex align-items-center justify-content-center">
                                                <h4 class="gallery-title m-0">{{ album.AlbumName || album.Name }}</h4>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Videos Section -->
                    <div class="mb-5" *ngIf="files.length != 0">
                        <div class="text-center mb-4">
                            <h2 class="ultimate-3d-title" style="font-size: 32px;">Videos</h2>
                            <div class="premium-header-divider mx-auto mt-2" style="width: 50px;"></div>
                        </div>
                        <div class="row g-4 justify-content-center">
                            <div class="col-lg-6 col-md-12" *ngFor="let item of files; let i = index">
                                <div class="ultimate-3d-card gallery-3d-card h-100 d-flex flex-column">
                                    <div class="video-iframe-wrapper"
                                        style="width: 100%; aspect-ratio: 16/9; position: relative;">
                                        <iframe [src]="convertToEmbedUrl(item.VideoId)" frameborder="0"
                                            webkitallowfullscreen mozallowfullscreen allowfullscreen
                                            style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; border-top-left-radius: 20px; border-top-right-radius: 20px;">
                                        </iframe>
                                    </div>
                                    <div class="gallery-content p-4 text-center flex-grow-1 d-flex align-items-center justify-content-center"
                                        style="border-top: 3px solid #0d8b54;">
                                        <p class="m-0" style="color: #0f4c3a; font-weight: 700; font-size: 16px;">
                                            {{ item.EnglishTitle || item.Title || item.Name || 'Video' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>

            </div>
        </div>
    </div>
</section>
